import PropTypes from 'prop-types';

const wirePropType = {
  wire: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};

export default wirePropType;
